import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import AvailableToPromiseReducer from "@sonic/Store/Components/AvailableToPromise/AvailableToPromiseReducer";
import AvailableToPromiseState from "@sonic/Store/Components/AvailableToPromise/AvailableToPromiseState";
import DealerAccountRequestFormReducer from "@sonic/Store/Components/DealerAccountRequestForm/DealerAccountRequestFormReducer";
import DealerAccountRequestFormState from "@sonic/Store/Components/DealerAccountRequestForm/DealerAccountRequestFormState";
import ProductDetailNavigationReducer from "@sonic/Store/Components/ProductDetailNavigation/ProductDetailNavigationReducer";
import ProductDetailNavigationState from "@sonic/Store/Components/ProductDetailNavigation/ProductDetailNavigationState";
import HeaderReducer from "@sonic/Store/Pages/Header/HeaderReducer";
import HeaderState from "@sonic/Store/Pages/Header/HeaderState";
import workOrderHistoryPageReducer from "@sonic/Store/Pages/WorkOrderHistory/WorkOrderHistoryReducer";
import WorkOrderHistoryState from "@sonic/Store/Pages/WorkOrderHistory/WorOrderHistoryState";

export type customerState = {
    dealerAccountRequestForm: DealerAccountRequestFormState;
    workOrderHistoryPageReducer: WorkOrderHistoryState;
    headerPage: HeaderState;
    productDetailNavigation: ProductDetailNavigationState;
    atpAvailable: AvailableToPromiseState;
} & ApplicationState;

(reducers as any).workOrderHistoryPageReducer = workOrderHistoryPageReducer;
(reducers as any).dealerAccountRequestForm = DealerAccountRequestFormReducer;
(reducers as any).headerPage = HeaderReducer;
(reducers as any).productDetailNavigation = ProductDetailNavigationReducer;
(reducers as any).atpAvailable = AvailableToPromiseReducer;
type Reducers = typeof reducers;

export type customerActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
